// Generated by generateKotlinApi; do not edit.
package io.github.erkko68.kolt.physics.collision

import io.github.erkko68.kolt.*
import io.github.erkko68.kolt.capi.*
import io.github.erkko68.kolt.core.*
import io.github.erkko68.kolt.core.capi.*
import io.github.erkko68.kolt.geometry.*
import io.github.erkko68.kolt.geometry.capi.*
import io.github.erkko68.kolt.interop.*
import io.github.erkko68.kolt.math.*
import io.github.erkko68.kolt.objectstream.*
import io.github.erkko68.kolt.physics.*
import io.github.erkko68.kolt.physics.body.*
import io.github.erkko68.kolt.physics.body.capi.*
import io.github.erkko68.kolt.physics.capi.*
import io.github.erkko68.kolt.physics.character.*
import io.github.erkko68.kolt.physics.character.capi.*
import io.github.erkko68.kolt.physics.collision.broadphase.*
import io.github.erkko68.kolt.physics.collision.broadphase.capi.*
import io.github.erkko68.kolt.physics.collision.capi.*
import io.github.erkko68.kolt.physics.collision.shape.*
import io.github.erkko68.kolt.physics.collision.shape.capi.*
import io.github.erkko68.kolt.physics.constraints.*
import io.github.erkko68.kolt.physics.constraints.capi.*
import io.github.erkko68.kolt.physics.constraints.constraintpart.*
import io.github.erkko68.kolt.physics.ragdoll.*
import io.github.erkko68.kolt.physics.ragdoll.capi.*
import io.github.erkko68.kolt.physics.softbody.*
import io.github.erkko68.kolt.physics.softbody.capi.*
import io.github.erkko68.kolt.physics.vehicle.*
import io.github.erkko68.kolt.physics.vehicle.capi.*
import io.github.erkko68.kolt.skeleton.*
import io.github.erkko68.kolt.skeleton.capi.*

/**
 * Filter class for object layers
 *
 * C++ `JPH::ObjectLayerFilter`.
 */
open class ObjectLayerFilter internal constructor(internal val objectLayerFilterHandle: NativePointer, owned: Boolean = false) : NativeObject(owned), AutoCloseable {
    /** Creates one whose functions a subclass overrides. */
    constructor() : this(JphObjectLayerFilter_createUpcalls(Upcalls.function), owned = true) {
        if (this::class != ObjectLayerFilter::class) JphObjectLayerFilter_bindUpcalls(objectLayerFilterHandle, Upcalls.reference(this))
    }

    override fun close() =
        closeOnce { JphObjectLayerFilter_destroy(objectLayerFilterHandle) }

    /** Function to filter out object layers when doing collision query test (return true to allow testing against objects with this layer) */
    open fun shouldCollide(layer: Int): Boolean =
        JphObjectLayerFilter_ShouldCollide(objectLayerFilterHandle, layer)

    override fun nativeUpcall(method: Int, args: NativePointer, result: NativePointer): Boolean {
        when (method) {
            0 -> writeSlot(result, if (shouldCollide(readSlot(args, 0).toInt())) 1L else 0L)
            else -> return false
        }
        return true
    }
}
